import { render } from "./TableExpirations.vue?vue&type=template&id=5758ccc9&scoped=true"
import script from "./TableExpirations.vue?vue&type=script&lang=js"
export * from "./TableExpirations.vue?vue&type=script&lang=js"

import "./TableExpirations.vue?vue&type=style&index=0&id=5758ccc9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5758ccc9"]])

export default __exports__